var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.25C0.585786 5.25 0.25 4.91421 0.25 4.5C0.25 4.08579 0.585786 3.75 1 3.75V5.25ZM3 13.75C2.58579 13.75 2.25 13.4142 2.25 13C2.25 12.5858 2.58579 12.25 3 12.25V13.75ZM11 5.25L1 5.25V3.75L11 3.75V5.25ZM11 13.75H3V12.25H11V13.75ZM11 3.75C11.1115 3.75 12.2588 3.74885 13.4015 4.33196C13.9839 4.62917 14.5801 5.08572 15.0282 5.78132C15.4783 6.48004 15.75 7.37504 15.75 8.5H14.25C14.25 7.62496 14.0418 7.01996 13.7672 6.59368C13.4906 6.16428 13.1171 5.87083 12.7197 5.66804C11.9027 5.25115 11.05 5.25 11 5.25V3.75ZM15.75 8.5C15.75 11.0006 14.6964 12.3802 13.4899 13.0851C12.348 13.7522 11.1793 13.75 11 13.75V12.25C11.1183 12.25 11.9496 12.2478 12.7333 11.7899C13.4524 11.3698 14.25 10.4994 14.25 8.5H15.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8C3.13317 6.63317 2.36683 5.86683 1 4.5C2.36683 3.13317 3.13317 2.36683 4.5 1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.d505dfb1136bc649eb20db49905e4ba6.svg";
export { ForwardRef as ReactComponent };